import React from 'react';
import FormDialog from '../../../library/form/components/FormDialog';
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormCheckbox from '../../../library/form/components/FormCheckbox';
import FormLabel from '../../../library/form/components/FormLabel';
import FormRichText from '../../../library/form/components/FormRichText';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormTitle from '../../../library/form/components/FormTitle';
import FormWrapper from '../../../library/form/components/FormWrapper';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormAttachment from '../../../library/form/components/FormAttachment';
import FormDropDown from '../../../library/form/components/FormDropDown';
import FormROValue from '../../../library/form/components/FormROValue1';

const InvItemDetailEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ height: '550px' }}
            contentStyle={{ height: '435px', width: "760px" }}
            formTitle={<FormTitle formObject={formObject} value='Order Item' />}
            formObject={formObject} >
            <div id="invitemDetailMain" className="uiitemDetailMain" >
                <div className="uiROHeader">
                    <div style={{ display: "inline-block" }}>
                        <FormAttachment formObject={formObject} rowKey="" imgHeight="50px" action={{ InputType: "i", paramName: "itemImage" }} />
                    </div>
                    <div id="itemDetailReadonly" style={{ display: "inline-block" }} >
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemIdReadOnly" }} value="Item" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "itemIdReadOnly" }} className='uiVal' />
                    </div>
                    <FormWrapper customWrapper="div" wrapperStyle={{ display: "inline-block" }} formObject={formObject} rowKey="" action={{ paramName: "itemSearchContainer" }} >
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemId" }} value="Item Id / No" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="20"
                            action={{ InputType: "input", paramName: "itemId" }} />
                        <FormButton formObject={formObject} rowKey="" className="uiSaveAction" text={<SarasTrans value="Update Item" />}
                            action={{ actionId: "refresh", actionParam: { changeitem: 1 } }}
                        />
                    </FormWrapper>
                    <FormWrapper customWrapper="div" wrapperStyle={{ display: "inline-block" }} formObject={formObject} rowKey="" action={{ paramName: "transCat" }} >
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "transCat" }} value="Category" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                            action={{ InputType: "ac", paramName: "transCat", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />
                    </FormWrapper>
                </div>
                <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "itemQtyContainer" }} >
                    <div>
                        <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "itemCostContainer1" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priceType" }} value="Price Type" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{
                                InputType: "ac", actionId: "refresh",
                                paramName: "priceType", acMethod: "PriceType", actionParam: { updateNetAmount: "1" }
                            }}
                            />
                        </FormWrapper>
                        <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "itemSalesContainer1" }} >
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taxTemplate" }} value="Tax" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{
                                InputType: "ac", actionId: "refresh", paramName: "taxTemplate",
                                acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' }, actionParam: { updateNetAmount: "1" }
                            }}
                            />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "includesTax" }} value="Price includes Tax" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey=''
                                action={{ InputType: "onOff", actionId: "refresh", paramName: "includesTax", actionParam: { updateNetAmount: "1" } }}
                            />
                        </FormWrapper>
                    </div>
                    <div>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qty1" }} value="Quantity" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                            action={{ InputType: "input", actionId: "refresh", paramName: "qty1", actionParam: { formulaSource: "QT1", updateNetAmount: "1" } }} />
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qty1uom" }} />
                        <FormWrapper customWrapper="div" wrapperClass="uiInline" formObject={formObject} rowKey="" action={{ paramName: "itemQty2Container" }} >
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qty2" }} value="and" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                                action={{ InputType: "input", actionId: "refresh", paramName: "qty2", actionParam: { formulaSource: "QT2", updateNetAmount: "1" } }} />
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qty2uom" }} />
                        </FormWrapper>
                    </div>
                    <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "ccQuantity" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ccQty1" }} value="Check Quantity" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24" action={{
                            InputType: "input", actionId: "refresh", paramName: "ccQty1",
                            actionParam: { formulaSource: "CC", updateNetAmount: "1" }
                        }} />
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qty1uom" }} />
                        <FormWrapper customWrapper="div" wrapperClass="uiInline" formObject={formObject} rowKey="" action={{ paramName: "itemQty2Container" }} >
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ccQty2" }} value="and" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24" action={{ InputType: "input", actionId: "refresh", paramName: "ccQty2", actionParam: { formulaSource: "CC", updateNetAmount: "1" } }} />
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qty2uom" }} />
                        </FormWrapper>
                    </FormWrapper>
                </FormWrapper>
                <div>
                    <ul className="uiItemPopupForm">
                        <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "itemCostContainer2" }} >
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "unitCost" }} >
                                <div className="uiColumn"> 
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "unitCost" }} value="Cost" />
                                    </span>
                                    <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "unitCost"}} />
                                    <span className="uiLblInLine">
                                        <SarasTrans value="per" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qty1uom" }} />
                                </div>
                            </FormWrapper>
                            <li>
                                <div className="uiColumn">
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "unitPrice" }} value="Unit Price" />
                                    </span>
                                    <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                                        action={{ InputType: "input", actionId: "refresh", paramName: "unitPrice", actionParam: { formulaSource: "UP", updateNetAmount: "1" } }} />
                                    <span className="uiLblInLine">
                                        <SarasTrans value="per" />
                                    </span>
                                    <FormDropDown formObject={formObject} rowKey="" action={{ actionId: "refresh", paramName: "sellPriceUnit", actionParam: { formulaSource: "UP", updateNetAmount: "1" } }} />
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "priceUnit" }} className='uiVal' />
                                </div>
                                <div className="uiColumn">
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "amtAfterQC" }} value="Total Amount" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "amtAfterQC" }} className='uiVal' />
                                </div>
                            </li>
                            <li>
                                <div className="uiColumn"> 
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "additionalCost" }} value="Other Charge" />
                                    </span>
                                    <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "additionalCost"}} />
                                </div>
                                <div className="uiColumn"> 
                                    <span className="uiLbl uiHighlightBlue">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "amountDue" }} value="Amount Due" />
                                    </span>
                                    <FormInput formObject={formObject} rowKey="" className="uiInput" 
                                        action={{ InputType: "input", actionId: "refresh", paramName: "amountDue", 
                                            actionParam: { formulaSource: "DSCP", updateNetAmount: "1" }}} />
                                </div>
                            </li>
                        </FormWrapper>
                        <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "itemSalesContainer2" }} >
                            <li>
                                <div className="uiColumn">
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "discAmt" }} value="Total Disc." />
                                    </span>
                                    <FormInput formObject={formObject} rowKey="" className="uiInput uiSpacerR2" maxlength="24"
                                        action={{ InputType: "input", actionId: "refresh", paramName: "discAmt", actionParam: { formulaSource: "DSC", updateNetAmount: "1" } }}
                                    />
                                    <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24" style={{ width: "50px" }}
                                        action={{ InputType: "input", actionId: "refresh", paramName: "discPerc", actionParam: { formulaSource: "DSCP", updateNetAmount: "1" } }}
                                    />
                                    <SarasTrans value="%" />
                                </div>
                                <div className="uiColumn">
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "netAmt" }} value="Before Tax" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "netAmt" }} className='uiVal' />
                                    <span className="uiLblInLine">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "totalTaxAmt" }} value="Tax" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "totalTaxAmt" }} className='uiVal' />
                                </div>
                            </li>
                            <li>
                                <div className="uiColumn">
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sellingAmt" }} value="Total Selling Price" />
                                    </span>
                                    <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                                        action={{ InputType: "input", actionId: "refresh", paramName: "sellingAmt", actionParam: { formulaSource: "SP", updateNetAmount: "1" } }}
                                    />
                                </div>
                                <div className="uiColumn">
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "grandAmt" }} value="Total After Tax" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "grandAmt" }} className='uiVal uiHighlightBlue' />
                                </div>
                            </li>
                        </FormWrapper>
                    </ul>
                </div>

                <div>
                    <ul className="uiItemPopupForm">
                        <li>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refNo" }} value="Reference No" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className=""
                                    action={{ InputType: "input", paramName: "refNo" }}
                                />
                            </div>
                            <div className="uiColumn">
                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "stockProfile" }} value="Profile" />
                                </span>
                                <FormInput format="#" formObject={formObject} rowKey="" className="uiInput" style={{width:"250px"}} 
                                    action={{
                                        InputType: "ac", paramName: "stockProfile", acMethod: "ProfileName", actionId: "refresh", actionParam: { updateProfile: 1 },
                                        acDepCtrl: { dparam: '%dataList.valLDT', reqPerm: 1 }
                                    }}
                                />
                            </div>
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "itemName" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemName" }} value="Reference Name" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInputLong"
                                action={{ InputType: "input", paramName: "itemName" }}
                            />
                        </FormWrapper>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemDesc" }} value="Description" />
                            </span>
                            <FormRichText formObject={formObject} rowKey="" id="delInstTxt" className="uiFrmText" rows="3" cols="82" maxlength="1000"
                                action={{ paramName: "itemDesc" }}
                            />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "packageContainer" }} >
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qtyPackage" }} value="Packing Qty" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                                    action={{ InputType: "input", paramName: "qtyPackage" }}
                                />
                            </div>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "packageUnit" }} value="Packing Unit" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" action={{
                                    InputType: "ac",
                                    actionId: "refresh", paramName: "packageUnit", acMethod: "Units", actionParam: { updateNetAmount: "1" }
                                }}
                                />
                            </div>
                        </FormWrapper>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "serviceDateContainer" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "fromDate" }} value="From Date" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "dp", paramName: "fromDate" }}
                            />

                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "toDate" }} value="To Date" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="relationSince" className="uiInput"
                                action={{ InputType: "dp", paramName: "toDate" }}
                            />
                        </FormWrapper>
                    </ul>
                </div>
            </div>

        </FormDialog>
    )
}

export default withView(InvItemDetailEditor, "itemDetail", "itemDetail,invTrnFooter,invTrans,ccbreakup,invTrnTracker")